import { render } from "./GoodItem.vue?vue&type=template&id=59650ae4&scoped=true"
import script from "./GoodItem.vue?vue&type=script&lang=js"
export * from "./GoodItem.vue?vue&type=script&lang=js"

import "./GoodItem.vue?vue&type=style&index=0&id=59650ae4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59650ae4"]])

export default __exports__